const MAX_RELOAD_ATTEMPTS = 2;
const RELOAD_ATTEMPT_KEY = "chunk_reload_attempts";

export function isChunkLoadError(error: Error): boolean {
  return /Failed to fetch dynamically imported module/i.test(error.message);
}

function getReloadAttempts(): number {
  try {
    const attempts = sessionStorage.getItem(RELOAD_ATTEMPT_KEY);
    return attempts ? parseInt(attempts, 10) : 0;
  } catch {
    return 0;
  }
}

function incrementReloadAttempts(): number {
  try {
    const current = getReloadAttempts();
    const next = current + 1;
    sessionStorage.setItem(RELOAD_ATTEMPT_KEY, next.toString());
    return next;
  } catch {
    return 0;
  }
}

function resetReloadAttempts(): void {
  try {
    sessionStorage.removeItem(RELOAD_ATTEMPT_KEY);
  } catch {
    // Ignore
  }
}

export function handleChunkLoadError(error: Error): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  // eslint-disable-next-line no-console
  console.error("Chunk load error detected:", error.message);

  const attempts = getReloadAttempts();

  if (attempts >= MAX_RELOAD_ATTEMPTS) {
    // eslint-disable-next-line no-console
    console.warn("Max reload attempts reached. User intervention required.");
    resetReloadAttempts();
    return false;
  }

  // eslint-disable-next-line no-console
  incrementReloadAttempts();

  window.location.reload();

  return true;
}

export function initChunkLoadErrorHandler(): void {
  resetReloadAttempts();

  window.addEventListener("unhandledrejection", (event) => {
    const error = event.reason;

    if (error instanceof Error && handleChunkLoadError(error)) {
      event.preventDefault();
    }
  });

  window.addEventListener("error", (event) => {
    if (event.error instanceof Error && handleChunkLoadError(event.error)) {
      event.preventDefault();
    }
  });

  // eslint-disable-next-line no-console
  console.log("Chunk load error handler initialized");
}

export function recoverFromChunkError(): void {
  resetReloadAttempts();
  window.location.reload();
}
